import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useRef } from "react";
import { Box } from "@quarkly/widgets";
import SectionContent from "./sectionContent";
import { useOverrides, useLazyHydrate, WHEN_VISIBLE } from "../hooks";
var overrides = {
  sectionContent: {
    props: {}
  }
};
var defaultProps = {
  as: "section",
  width: "100%",
  margin: "0",
  padding: "24px 0",
  "inner-width": "--cmp-section-width-default",
  "inner-min-width": "--cmp-section-minWidth-default",
  "inner-max-width": "--cmp-section-maxWidth-default",
  "lazy-load": true
};

var Section = function Section(_ref) {
  var iw = _ref["inner-width"],
      imaxw = _ref["inner-max-width"],
      iminw = _ref["inner-min-width"],
      lazyLoad = _ref["lazy-load"],
      props = _objectWithoutProperties(_ref, ["inner-width", "inner-max-width", "inner-min-width", "lazy-load"]);

  var _useOverrides = useOverrides(props, overrides, defaultProps),
      override = _useOverrides.override,
      children = _useOverrides.children,
      rest = _useOverrides.rest;

  var ref = useRef(null);
  var render = useLazyHydrate({
    strategy: WHEN_VISIBLE
  }, ref);

  if (!render && lazyLoad) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      display: "flex"
    }, rest, {
      ref: ref,
      dangerouslySetInnerHTML: {
        __html: ""
      }
    }));
  }

  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionContent, _extends({
    iw: iw,
    imaxw: imaxw,
    iminw: iminw
  }, override("SectionContent")), children));
};

var propInfo = {
  "inner-width": {
    weight: 1,
    library: "components.section.width",
    control: "input",
    transformer: "width",
    category: "Main"
  },
  "inner-min-width": {
    weight: 1,
    library: "components.section.minWidth",
    control: "input",
    transformer: "width",
    category: "Main"
  },
  "inner-max-width": {
    weight: 1,
    library: "components.section.maxWidth",
    control: "input",
    transformer: "width",
    category: "Main"
  },
  "lazy-load": {
    type: "boolean",
    control: "checkbox",
    category: "Main"
  }
};
var effects = {
  hover: ":hover"
};
export default Object.assign(Section, {
  overrides: overrides,
  defaultProps: defaultProps,
  effects: effects,
  propInfo: propInfo
});